import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Accueil',      to: '/' },
  { label: "L'Atelier",    to: '/atelier' },
  { label: 'Collections',  to: '/collections' },
  { label: 'Lunettes',     to: '/lunettes' },
  { label: 'Lentilles',    to: '/lentilles' },
  { label: 'Ordonnance',   to: '/ordonnance' },
  { label: 'Contact',      to: '/contact' },
];

// Routes qui doivent activer "Collections" dans la nav
const COLLECTIONS_SUBROUTES = ['/montures', '/verres', '/solaires'];

export const NavBar = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (to) => {
    if (to === '/') return location.pathname === '/';
    if (to === '/collections') {
      return (
        location.pathname === '/collections' ||
        COLLECTIONS_SUBROUTES.some((r) => location.pathname.startsWith(r))
      );
    }
    return location.pathname.startsWith(to);
  };

  return (
    <nav className="nav-bar">
      <div className="nav-content">
        <Link to="/" className="nav-brand nav-brand-link" onClick={() => setMobileMenuOpen(false)}>
          <img src="/logo.png" alt="Lunetterie du Russey" className="nav-logo" />
          <span>Lunetterie du Russey</span>
        </Link>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen((o) => !o)}
          aria-label={mobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <div className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          {NAV_LINKS.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className={`nav-link ${isActive(to) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};
